import { sf_mucthuphi_select_request } from "../models/request/mucthuphi/sf_mucthiphi_select_rq";
import { apiClient } from "./apiClient";

export interface CongNoSelectByHocSinhRequest {
  ts_hocsinh_id: number;
  nam_hoc: string;
}

export const baoCaoHocPhiApi = {
  reportAlpha: (request: sf_mucthuphi_select_request) => {
    return apiClient.post(`baocao_hocphi/report-congno-alpha`, request);
  },
  reportCongNoAll: (request: sf_mucthuphi_select_request) => {
    return apiClient.post(`baocao_hocphi/report-congno-all`, request);
  },
  exportCongNoAll: (request: sf_mucthuphi_select_request) => {
    return apiClient.postBlob(`baocao_hocphi/export-congno-all`, request);
  },
  SelectDashBoard: (request: any) =>
    apiClient.post(`baocao_hocphi/dashboard-cong-no`, request),
  selectByHocSinh: (request: CongNoSelectByHocSinhRequest) =>
    apiClient.post(`baocao_hocphi/select_by_hocsinh`, request),
  previewCongNoHocSinh: (request: any) =>
    apiClient.post(`baocao_hocphi/preview-congno-hocsinh`, request),
  exportCongNoHocSinhExcel: (request: any) =>
    apiClient.postBlob(`baocao_hocphi/export-congno-hocsinh-excel`, request),
  exportCongNoHocSinhPdf: (request: any) =>
    apiClient.postBlob(`baocao_hocphi/export-congno-hocsinh-pdf`, request),
  getEmailContentCongNoHocSinh: (request: any) =>
    apiClient.post(`baocao_hocphi/get-email-content-congno-hocsinh`, request),
  sendEmailCongNoHocSinh: (request: any) =>
    apiClient.post(`baocao_hocphi/send-email-congno-hocsinh`, request),
};
